import { render, staticRenderFns } from "./editStoreAttr.vue?vue&type=template&id=3171c76c"
import script from "./editStoreAttr.vue?vue&type=script&lang=js"
export * from "./editStoreAttr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports